import AppAuthProviderContext from "@/providers/AppAuthProvider/context"
import { useContext } from "react"

const useAuth = () => useContext(AppAuthProviderContext)
export default useAuth
